
import styles from "./sales-snapshot-cards.module.css";
import { useDashboardDispatch, useDashboardContext } from "@/contexts/DashboardContext";
import { getOrderItemSalesBreakdown, getProductSalesBreakdown, getSellerSalesBreakdown, getSellerSalesSnapshot } from "@/api/seller-analytics";
import SalesSnapshotCard from "../SalesSnapshotCard/SalesSnapshotCard";
import { DateRangeValue } from "@/utils/dateUtils";
import { LocalStorageKeys, setLocalStorageItem } from "@/utils/localStorageUtils";

const SalesSnapshotCards = () => {

  const { salesSnapshotCards, activeSnapshotIndex, activeBreakdownTab, productSalesBreakdown } = useDashboardContext();
  const dispatch = useDashboardDispatch();

  const handleSnapshotIntervalChange = async (cardIndex: number, interval: DateRangeValue) => {
    dispatch({ type: 'SNAPSHOT_INTERVAL_CHANGED', data: { cardIndex, interval } });
    setLocalStorageItem(LocalStorageKeys.salesSnapshotIntervals, JSON.stringify(salesSnapshotCards.map((snapshot, i) => cardIndex === i ? interval : snapshot.defaultInterval)));

    const salesByInterval = await getSellerSalesSnapshot([interval])

    dispatch({ type: 'SNAPSHOT_DATA_LOADED', data: { cardIndex, salesData: salesByInterval } });

    if (activeSnapshotIndex === cardIndex) {
      dispatch({ type: 'BREAKDOWN_INTERVAL_CHANGED' })

      if (activeBreakdownTab === 'products') {
        const productSalesResponse = await getProductSalesBreakdown(
          interval)
        dispatch({ type: 'PRODUCT_SALES_BREAKDOWN_DATA_LOADED', data: { tableData: productSalesResponse } })
      } else if (activeBreakdownTab === 'order-items') {
        const orderItemsalesResponse = await getOrderItemSalesBreakdown(
          interval)
        dispatch({ type: 'ORDER_ITEM_SALES_BREAKDOWN_DATA_LOADED', data: { tableData: orderItemsalesResponse } })
      } else {
        const salesBreakdown = await getSellerSalesBreakdown(interval)
        dispatch({ type: 'SALES_BREAKDOWN_DATA_LOADED', data: { breakdownData: salesBreakdown } })
      }
    }
  }

  const handleSnapshotCardClick = async (cardIndex: number, interval: DateRangeValue) => {
    if (activeSnapshotIndex !== cardIndex) {
      dispatch({ type: 'SNAPSHOT_CARD_CLICKED', data: { cardIndex } });

      if (activeBreakdownTab === 'products') {
        const productSalesResponse = await getProductSalesBreakdown(interval)
        dispatch({ type: 'PRODUCT_SALES_BREAKDOWN_DATA_LOADED', data: { tableData: productSalesResponse } })
      } else if (activeBreakdownTab === 'order-items') {
        const orderItemsalesResponse = await getOrderItemSalesBreakdown(
          interval)
        dispatch({ type: 'ORDER_ITEM_SALES_BREAKDOWN_DATA_LOADED', data: { tableData: orderItemsalesResponse } })
      } else {
        const salesBreakdown = await getSellerSalesBreakdown(interval)
        dispatch({ type: 'SALES_BREAKDOWN_DATA_LOADED', data: { breakdownData: salesBreakdown } })
      }

      window.localStorage.setItem(LocalStorageKeys.activeSnapshotIndex, cardIndex.toString());
    }
  }

  return (<div className={styles.snapshotCards}>
    {salesSnapshotCards && salesSnapshotCards.map((cardData, i) => (
      <SalesSnapshotCard
        key={i}
        {...cardData}
        activeSnapshotIndex={activeSnapshotIndex}
        cardIndex={i}
        onChangeInterval={handleSnapshotIntervalChange}
        onClick={handleSnapshotCardClick}
      />
    ))}
  </div>);
}

export default SalesSnapshotCards;